import { Link } from 'braid-design-system';
import React from 'react';

import {
  createNavLinks,
  getLoginNavButtonProps,
  navLinkIds,
} from '../utils/generalUtils';

import * as styles from './NavTextLink.css';

interface NavTextLinkInstanceProps {
  baseUrl: string;
}

export const RegisterTextLink = ({ baseUrl }: NavTextLinkInstanceProps) => (
  <NavTextLink
    id={navLinkIds.register}
    href={createNavLinks(baseUrl).register}
    name="Register"
  />
);

export const SignInTextLink = ({ baseUrl }: NavTextLinkInstanceProps) => (
  <NavTextLink
    id={navLinkIds.signIn}
    href={createNavLinks(baseUrl).signIn}
    name="Sign in"
  />
);

// ============================================================================
// NavTextLink
// ============================================================================

interface NavTextLinkProps {
  id: string;
  href: string;
  name: string;
}

const NavTextLink = ({ id, href, name }: NavTextLinkProps) => (
  <Link
    {...getLoginNavButtonProps(href)}
    id={id}
    className={styles.mobileNavAccountButton}
    data={{ htag: id }}
  >
    <span className={styles.mobileMenuItemText}>{name}</span>
  </Link>
);
